import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useState } from 'react';
import NewScreenModal from 'modules/dashboard/screens/Create';
import PlaylistHeader from './PlaylistHeader';
import PlaylistTable from './PlaylistTable';

const PlaylistTabs = () => {
  const { id } = useParams<{ id: string }>();
  const [isNewScreenModalOpen, setIsNewScreenModalOpen] = useState(false);

  return (
    <Container>
      <PlaylistHeader
        onNewPlaylist={() => setIsNewScreenModalOpen(true)}
        id={id || ''}
      />
      <PlaylistTable id={id || ''} />
      <NewScreenModal
        open={isNewScreenModalOpen}
        onClose={() => setIsNewScreenModalOpen(false)}
      />
    </Container>
  );
};

export default PlaylistTabs;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
